import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  size?: number;
};

const BracketsCheckLightIcon: FC<Props> = ({ size = 40 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 40 40"
  >
    <path
      stroke={colors['--green-500']}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13.336 8.332h-5v23.333h5M26.664 8.332h5v23.333h-5M15.836 20l3.333 3.333L25.003 15"
    />
  </svg>
);

export default BracketsCheckLightIcon;
